function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.5 10L5 14l4.5-4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.5 0h1v14h-1z"
}));

function SvgCaptionArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 15
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMCIgaGVpZ2h0PSIxNSIgdmlld0JveD0iMCAwIDEwIDE1Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTMgMTYuNUw3IDEyIDMgNy41IiB0cmFuc2Zvcm09InJvdGF0ZSg5MCA1IDEyKSIvPgogICAgICAgIDxwYXRoIGQ9Ik00LjUgMEg1LjVWMTRINC41eiIvPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgCaptionArrow as ReactComponent };